import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

var AJAX_START = "AJAX_START";
var AJAX_SUCCESS = "AJAX_SUCCESS";
var AJAX_ERROR = "AJAX_ERROR";
var AJAX_SLOW = "AJAX_SLOW";
var AJAX_RESET = "AJAX_RESET";
var AJAX_ABORT = "AJAX_ABORT"; // helper functions

var isAjaxStart = function isAjaxStart(action) {
  return action.subtype === AJAX_START;
};

var isAjaxSuccess = function isAjaxSuccess(action) {
  return action.subtype === AJAX_SUCCESS;
};

var isAjaxError = function isAjaxError(action) {
  return action.subtype === AJAX_ERROR;
};

var isAjaxSlow = function isAjaxSlow(action) {
  return action.subtype === AJAX_SLOW;
};

var isAjaxReset = function isAjaxReset(action) {
  return action.subtype === AJAX_RESET;
};

var isAjaxAbort = function isAjaxAbort(action) {
  return action.subtype === AJAX_ABORT;
};

var ajaxActionsFor = function ajaxActionsFor(type) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeout = null;
  return {
    reset: function reset() {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_RESET
      });
    },
    start: function start(request) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_START,
        sentAt: Date.now(),
        request: request
      });
    },
    slow: function slow(to) {
      return function (dispatch) {
        timeout = setTimeout(function () {
          dispatch(_objectSpread2(_objectSpread2({}, obj), {}, {
            type: type,
            subtype: AJAX_SLOW,
            slow: true
          }));
        }, to);
      };
    },
    success: function success(response) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_SUCCESS,
        receivedAt: Date.now(),
        response: response
      });
    },
    error: function error(_error) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_ERROR,
        receivedAt: Date.now(),
        error: _error
      });
    },
    abort: function abort(reason) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        type: type,
        subtype: AJAX_ABORT,
        abortedAt: Date.now(),
        reason: reason
      });
    }
  };
};

export { AJAX_ABORT, AJAX_ERROR, AJAX_RESET, AJAX_SLOW, AJAX_START, AJAX_SUCCESS, ajaxActionsFor, isAjaxAbort, isAjaxError, isAjaxReset, isAjaxSlow, isAjaxStart, isAjaxSuccess };
